// extracted by mini-css-extract-plugin
export default {"socialLinksContainer":"w6SfuXOqiknUR8DkPmZg","blackBoxStyle":"uE7IlGpDxPRM44ZxREtA","socialLink":"bgU6X7TaynuJc4fkC42R","borderLinkWrapper":"vJYrO6rLeVsuhF9bzE5D"};